import { Injectable, signal } from '@angular/core';

@Injectable({ providedIn: 'root' })
export class ContextService {
  readonly ctxParam = signal<string>('');

  setCtxParam(value: string | null | undefined) {
    this.ctxParam.set((value ?? '').trim());
  }

  clear() {
    this.ctxParam.set('');
  }
}
